import { render, staticRenderFns } from "./SetLabels.vue?vue&type=template&id=311d29b8"
import script from "./SetLabels.vue?vue&type=script&lang=js"
export * from "./SetLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports